export const LOGIC_COLOR = 210;
export const LOOPS_COLOR = 120;
export const MATH_COLOR = 230;
export const TEXT_COLOR = 160;
export const VAR_COLOR = 330;
export const PROCEDURE_COLOR = 290;
export const ARDUINO_COLOR = 120;
export const IO_COLOR = 210;
export const SERIAL_COLOR = 30;
export const BEGINNER_BASIC_COLOR = 160;
export const BEGINNER_LED_COLOR = 20;
export const BEGINNER_SWITCH_COLOR = 260;
export const BEGINNER_SOUND_COLOR = 80;
export const BEGINNER_DISPLAY_COLOR = 210;
export const BEGINNER_TIME_COLOR = 290;
export const BEGINNER_SERIAL_COLOR = 30;

export type ToolboxOperationMode = 'beginner' | 'advanced';
